import { Embed } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { ErrorBoundary } from '../../../common/components/ErrorBoundary/ErrorBoundary.js'

import { EmbedRenderer } from './EmbedRenderer.js'

interface Props {
  embed: Embed
  onRemove: (embed: Embed) => void
}

export const ComposerEmbedRenderer = ({ embed, onRemove }: Props) => {
  if (!embed.thumbnail_url && !embed.url) {
    return null
  }

  return (
    <div className="relative group">
      <div className="max-w-[15rem] max-h-full border border-line rounded-base">
        <ErrorBoundary>
          <EmbedRenderer embed={embed} />
        </ErrorBoundary>
      </div>
      <div
        className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 z-10 bg-surface-subdued rounded-full p-1 hover:bg-surface-subdued-hovered opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-200 cursor-pointer"
        onClick={e => {
          e.stopPropagation()
          onRemove(embed)
        }}
      >
        <SvgIcon name="close" />
      </div>
    </div>
  )
}
